import { WebSocketMessageTypeOutgoing } from '../../Enums/WebSocketMessageTypeOutgoing';
import { MessageWebSocketOutgoing } from './MessageWebSocketOutgoing';

export class RequestTransputStates extends MessageWebSocketOutgoing {
  constructor() {
    super();
    this.Type = WebSocketMessageTypeOutgoing.WsRequestTransputStates;
  }
}
